<template>
  <div id="app" :class="[$route.meta.belong !== 'air-service' ? 'dhr' : 'air-service']">
    <router-view name="navigation"></router-view>
    <transition name="router-fade" mode="out-in">
      <keep-alive>
        <router-view :class="[$route.meta.belong === 'air-service' ? 'air-service-container' : 'dhr-container']"
          v-if="$route.meta.keepAlive">
        </router-view>
      </keep-alive>
    </transition>
    <transition name="router-fade" mode="out-in">
      <router-view :class="[$route.meta.belong === 'air-service' ? 'air-service-container' : 'dhr-container']"
        v-if="!$route.meta.keepAlive">
      </router-view>
    </transition>
    <dialogs />
  </div>
</template>

<script>
import dialogs from '@/components/common/dialog/dialog-set'
export default {
  name: 'app',
  data: function () {
    return {
    }
  },
  components: { dialogs }
}
</script>
<style lang="less">
@import './pages/air-service/style/common.less';
</style>
<style lang="less" scoped>
#app {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  color: #333;
  font-size: 14px;
  line-height: 1;
  background-color: #EDF0F4;
  box-sizing: border-box;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6 {
    font-family: inherit;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
  }
}

.dhr {
  // padding: 6px 14px;
  background-color: #eeeff1;
}

.dhr-container {}

.air-service-container {
  background-color: #EDF0F4;
}

.router-fade-enter-active,
.router-fade-leave-active {
  transition: opacity .3s;
}

.router-fade-enter,
.router-fade-leave-active {
  opacity: 0;
}</style>


// WEBPACK FOOTER //
// App.vue?0bb1de78